/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Link_Conflict_TitleInputs */



/**
* | output |
* | --- |
* | "This calendar is already in use" |
*
* @param {Connections_Link_Conflict_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_link_conflict_title = /** @type {((inputs?: Connections_Link_Conflict_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Link_Conflict_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze agenda is al in gebruik")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cet agenda est déjà utilisé")
	return /** @type {LocalizedString} */ ("This calendar is already in use")
});